export default {

  name: '',
  email: '',
  phone: '',
  note: '',

  items: []

};
